<template>
<div :class="[ shit$(`fixed; `), shit$(`top:${rect.top}px; left:${rect.left}px; z:${rect.z};`) ]">
    <div ref="rect" :class="[
      shit$(`w:${executeWd.clientW}px; bgc:#fff; radius:10px;`), // w:${executeWd.clientW}px; h:${executeWd.clientH}px;
      shit$(`pt:17px; pb:20px; pl:30px; pr:17px; border:none;`)
    ]">
      <div :class="[ shit$(`dis:f; justify-c:sb; align-i:c;`) ]">
        <span :class="shit$(`c:#00b5e2; font:${ isi18n ? 18 : 20 }px; font-w:500; letter-s:2px;`)">{{ o.header_t1 }}</span>
        <span @click="$store.dispatch('introStore/excuteNextTick_', [ { oof: 0 } ])" :class="shit$(`c:#696969; font:14px; font-w:500; letter-s:1px; text-decoration:underline; cursor:p;`)">{{ o.header_t2 }}</span>
      </div>
      <img :src="o.img" v-if="o.img" :class="shit$(`w:400px; h:268px; relative; left:-30px; top:10px;`)" />
      <p :class="[shit$(`c:#000; font:${ isi18n ? 14 : 16 }px; font-w:500; letter-s:1.14px; lh:1.38; mt:25px;`)]">
        <span>{{ o.content_t1 }}</span>
        <span v-if="o.content_t2" :class="shit$(o.content_t2_shit)">{{ o.content_t2 }}</span>
      </p>
      <section :class="shit$(`dis:f; justify-c:sb; mt:20px; align-i:c;`)"> 
        <span @click="$store.dispatch('introStore/excuteNextTick_', [ { oof: -1 } ])" :class="shit$(`c:#696969; font:14px; font-w:500; letter-s:1px; text-decoration:underline; cursor:p;`)">{{ o.btn_t_1 }}</span>
        <div @click="$store.dispatch('introStore/excuteNextTick_')" :class="[ shit$(`w:160px; h:40px; radius:32.5px; bgc:#0ed3ff; c:#fff; font:16px; font-w:500; letter-s:0.48px; text-a:c; lh:40px; cursor:p;`), shit$(o.btn_t1_shit)]">{{ o.btn_t1 }}</div>
      </section>
    </div>
    <div :class="[ 'sjx', shit$(`transform:rotate(${triangle.rotate}deg); top:${triangle.top}px; right:${triangle.right}px;`) ]"></div>
</div>
</template>

<script>
import { mapState } from 'vuex'
const Cookies = window.Cookies;
export default {
  data () {
    return {
      triangle: {},
      langs: [ 'ja', 'en' ]
    }
  },
  computed: {
    ...mapState('introStore', {
      rect: 'rect',
      executeWd: 'executeWd',
      o: o => o.executeWd.data,
      showBlockWindow: 'showBlockWindow'
    }),
    isi18n () { return this.langs.includes(Cookies.get("langCode")) }
  },
  methods: {
    computedAdapt () {
      // console.log( this.$refs.rect )
      const r = this.$refs.rect.getBoundingClientRect()
      const w = document.documentElement.getBoundingClientRect()
      if (r.bottom >= w.bottom && this.executeWd.position === 'right') return true
    }
  },
  watch: {
    rect: {
      handler (rect) {
          this.$nextTick(() => {
            const { md, hh, offset, ww, rr } = rect
            const ref = this.$refs.rect
            console.log(ref.clientHeight, this.computedAdapt())
            const arr = {
              right: { rotate: 135, right: -12, top: this.computedAdapt() ? ref.clientHeight - 40 : ref.clientHeight - offset - (hh / 2) - 18 },
              top: { rotate: 45, right: ww / 2 - 6 - rr, top: -12 },
              left: { rotate: 315, right: ref.clientWidth - 14, top: ref.clientHeight - offset - (hh / 2) - 18 },
              bottom: { rotate: 225, right: ww / 2 - 6 - rr, top: ref.clientHeight - offset - 14 },
            }
            const data = arr[ md ]
            this.triangle =  data
          })


        // this.$nextTick(() => {
        //   const { md, hh, offset, ww, rr } = rect
        //   const ref = this.$refs.rect
        //   const arr = {
        //     right: { rotate: 135, right: -12, top: ref.clientHeight - offset - (hh / 2) - 18 },
        //     top: { rotate: 45, right: ww / 2 - 6 - rr, top: -12 },
        //     left: { rotate: 315, right: ref.clientWidth - 14, top: ref.clientHeight - offset - (hh / 2) - 18 },
        //   }
        //   const data = arr[ md ]
        //   this.triangle =  data
        // })
      }
    },
    showBlockWindow: {
      // immediate: true,
      handler (val) {
        console.log('chenged! -> ', val, )
        // if (val) {
        //   this.$nextTick(() => {
        //     const { md, hh, offset, ww, rr } = this.rect
        //     const ref = this.$refs.rect
        //     console.log(ref.clientHeight, this.computedAdapt())
        //     const arr = {
        //       right: { rotate: 135, right: -12, top: this.computedAdapt() ? ref.clientHeight - 40 : ref.clientHeight - offset - (hh / 2) - 18 },
        //       top: { rotate: 45, right: ww / 2 - 6 - rr, top: -12 },
        //       left: { rotate: 315, right: ref.clientWidth - 14, top: ref.clientHeight - offset - (hh / 2) - 18 },
        //       bottom: { rotate: 225, right: ww / 2 - 6 - rr, top: ref.clientHeight - offset - 14 },
        //     }
        //     const data = arr[ md ]
        //     this.triangle =  data
        //   })
        // }
      }
    }
  },
}
</script>

<style scoped>
.sjx {
    width: 0px;
    height: 0px;
    border-width: 14px;
    border-color: #fff transparent transparent #fff;
    border-style: solid;
    border-top-left-radius: 5px;
    position: absolute;
}
</style>
